/**
 * Module dependencies.
 */

import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { TechnologyProps } from 'src/types/technologies';
import { fetchTechnologies } from './fetch-technologies';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<TechnologyProps[], unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<TechnologyProps[]> & {
  filterParams: any;
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-technologies`;
};

/**
 * `useTechnologies` hook.
 */

function useTechnologies(options: Options): Result {
  const { filterParams, ...rest } = options;
  const { locale } = useRouter();
  const variables = useMemo(
    () => ({
      locale,
      params: {
        filter: filterParams
      }
    }),
    [filterParams, locale]
  );

  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchTechnologies(variables);
    },
    rest
  );

  return result;
}

/**
 * Export `useTechnologies` hook.
 */

export default useTechnologies;
